import { cx } from '@growup/ui';
import { useState } from 'react';

import { CalendarView } from './CalendarView';
import { IdeasView } from './IdeasView';
import { PeopleView } from './PeopleView';
import { PlansView } from './PlansView';

type Tab = 'planos' | 'calendario' | 'pessoas' | 'ideias';

const TABS: { id: Tab; label: string }[] = [
  { id: 'planos', label: 'Planos' },
  { id: 'calendario', label: 'Calendário' },
  { id: 'pessoas', label: 'Por pessoa' },
  { id: 'ideias', label: 'Banco de ideias' },
];

/**
 * Seccao Redes sociais (docs/redes-sociais): o Gestor de Redes Sociais gere
 * planos e ideias; um influencer ve os planos onde esta designado e o banco.
 */
export function SocialSection({
  canManage,
  me,
  initialPlan = null,
}: {
  canManage: boolean;
  me: string;
  /** Abre logo este plano (vindo de um evento). */
  initialPlan?: string | null;
}) {
  const [tab, setTab] = useState<Tab>('planos');
  // O plano a abrir quando se vem do Calendario; a chave volta a montar a lista.
  const [plan, setPlan] = useState<{ id: string | null; key: number }>({
    id: initialPlan,
    key: 0,
  });
  return (
    <>
      <nav className="flex flex-wrap gap-1" aria-label="Redes sociais">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            aria-current={tab === t.id ? 'page' : undefined}
            onClick={() => {
              if (t.id === 'planos') setPlan((p) => ({ id: null, key: p.key + 1 }));
              setTab(t.id);
            }}
            className={cx(
              'border-b-2 px-3 py-2 font-sub text-label font-bold uppercase',
              tab === t.id
                ? 'border-gu-accent text-gu-ink'
                : 'border-transparent text-gu-ink-muted hover:text-gu-ink',
            )}
          >
            {t.label}
          </button>
        ))}
      </nav>
      {tab === 'planos' ? (
        <PlansView key={plan.key} canManage={canManage} me={me} initialPlan={plan.id} />
      ) : null}
      {tab === 'calendario' ? (
        <CalendarView
          onOpenPlan={(id) => {
            setPlan((p) => ({ id, key: p.key + 1 }));
            setTab('planos');
          }}
        />
      ) : null}
      {tab === 'pessoas' ? <PeopleView /> : null}
      {tab === 'ideias' ? <IdeasView canManage={canManage} /> : null}
    </>
  );
}
